<template>
    <MenuBase :hidden="props.hidden" 
        :tooltipPosition="props.tooltipPosition" :theme="props.theme" 
        :tooltipText="props.tooltipText"
        @menuClick="toggleStudio()">
        <WaveIcon class="size-6" />
    </MenuBase>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
import WaveIcon from '@/components/icons/WaveIcon.vue';
import MenuBase from '@/components/common/menus/MenuBase.vue';

const emit = defineEmits(['toggleStudio'])
const props = defineProps( {
    disabled: {
        type: Boolean,
        default: true
    },
    hidden: {
        type: Boolean,
        default: true
    },
    tooltipPosition: {
        type: String,
        default: 'top'
    },
    active: {
        type: Boolean,
        default: true
    },
    theme: {
        type: String,
        default: 'light'
    },
    tooltipText: {
        type: String,
        default: 'Show chords'
    }
})

const toggleStudio = () => {
    emit('toggleStudio');
}
</script>